export enum ProfilesEnum {
  Fresher = 'Fresher',
  Experience = 'Experience'
}